const __vite__mapDeps = (
  i,
  m = __vite__mapDeps,
  d = m.f ||
    (m.f = [
      "./dialog-BaBkMkeu.js",
      "./component-C-rYG68G.js",
      "./utilities-BYG85iVY.js",
      "./events-CnaEWcY_.js",
      "./dialog-Ct27NoCm.css",
      "./carousel-embla-g3Tm5yad.js",
      "./embla-tQScX_QI.js",
      "./predictive-search-Cg925ss_.js",
      "./morph-DJHIeiMC.js",
    ])
) => i.map((i) => d[i]);
import "./liquid-ajax-cart-CD-8Lu3e.js";
import { C as h, b as x, c as L } from "./events-CnaEWcY_.js";
import { f as S } from "./utilities-BYG85iVY.js";
const A = "modulepreload",
  P = function (t, e) {
    return new URL(t, e).href;
  },
  E = {},
  m = function (e, r, o) {
    let a = Promise.resolve();
    if (r && r.length > 0) {
      let j = function (s) {
        return Promise.all(
          s.map((d) =>
            Promise.resolve(d).then(
              (l) => ({ status: "fulfilled", value: l }),
              (l) => ({ status: "rejected", reason: l })
            )
          )
        );
      };
      const n = document.getElementsByTagName("link"),
        c = document.querySelector("meta[property=csp-nonce]"),
        y = c?.nonce || c?.getAttribute("nonce");
      a = j(
        r.map((s) => {
          if (((s = P(s, o)), s in E)) return;
          E[s] = !0;
          const d = s.endsWith(".css"),
            l = d ? '[rel="stylesheet"]' : "";
          if (o)
            for (let f = n.length - 1; f >= 0; f--) {
              const p = n[f];
              if (p.href === s && (!d || p.rel === "stylesheet")) return;
            }
          else if (document.querySelector(`link[href="${s}"]${l}`)) return;
          const u = document.createElement("link");
          if (
            ((u.rel = d ? "stylesheet" : A),
            d || (u.as = "script"),
            (u.crossOrigin = ""),
            (u.href = s),
            y && u.setAttribute("nonce", y),
            document.head.appendChild(u),
            d)
          )
            return new Promise((f, p) => {
              (u.addEventListener("load", f),
                u.addEventListener("error", () => p(new Error(`Unable to preload CSS for ${s}`))));
            });
        })
      );
    }
    function i(n) {
      const c = new Event("vite:preloadError", { cancelable: !0 });
      if (((c.payload = n), window.dispatchEvent(c), !c.defaultPrevented)) throw n;
    }
    return a.then((n) => {
      for (const c of n || []) c.status === "rejected" && i(c.reason);
      return e().catch(i);
    });
  };
let w = !1;
function b() {
  w ||
    ((w = !0),
    document.addEventListener("liquid-ajax-cart:init", () => {
      const t = window.liquidAjaxCart?.cart ?? null;
      document.dispatchEvent(
        new h(t, "liquid-ajax-cart:init", {
          source: "liquid-ajax-cart",
          itemCount: t?.item_count ?? 0,
        })
      );
    }),
    document.addEventListener("liquid-ajax-cart:request-end", (t) => {
      const { requestState: e } = t.detail,
        r = window.liquidAjaxCart?.cart ?? null;
      if (!e.responseData?.ok || e.fetchError) {
        const i = e.responseData?.body ?? {};
        document.dispatchEvent(
          new x(
            "liquid-ajax-cart",
            i.message ?? e.fetchError ?? "Cart request failed",
            i.description ?? null,
            i.errors ?? null
          )
        );
        return;
      }
      const a = {
        source: "liquid-ajax-cart",
        requestType: e.requestType,
        itemCount: r?.item_count ?? 0,
        sections: e.requestBody?.sections ?? null,
      };
      e.requestType === "add"
        ? document.dispatchEvent(new L(r, "liquid-ajax-cart", a))
        : document.dispatchEvent(new h(r, "liquid-ajax-cart", a));
    }));
}
let q = !1;
function C() {
  const e = document.querySelector("[data-engraving-fee-variant-id]")?.dataset
      .engravingFeeVariantId,
    r = e ? parseInt(e, 10) : NaN;
  return Number.isNaN(r) ? null : r;
}
function k(t) {
  if (!t.properties) return !1;
  const e = t.properties.Gravur ?? t.properties.Engraving ?? null;
  return typeof e == "string" && e.trim().length > 0;
}
async function T() {
  if (q) return;
  const t = C();
  if (!t) return;
  const e = window.liquidAjaxCart?.cart;
  if (!e?.items) return;
  const r = e.items.filter((n) => n.variant_id === t),
    a = e.items.filter((n) => n.variant_id !== t).filter(k).length;
  if (!(r.reduce((n, c) => n + c.quantity, 0) === a && r.length <= 1)) {
    q = !0;
    try {
      for (let c = 1; c < r.length; c++) await v(r[c].key, 0);
      const n = r[0];
      a === 0
        ? n && (await v(n.key, 0))
        : n
          ? n.quantity !== a && (await v(n.key, a))
          : await D(t, a);
    } finally {
      q = !1;
    }
  }
}
function v(t, e) {
  return new Promise((r) => {
    const o = new FormData();
    (o.append("id", t), o.append("quantity", String(e)));
    const a = (i) => {
      const { requestState: n } = i.detail ?? {};
      n?.requestType === "change" &&
        (document.removeEventListener("liquid-ajax-cart:request-end", a), r());
    };
    (document.addEventListener("liquid-ajax-cart:request-end", a), window.liquidAjaxCart.change(o));
  });
}
function D(t, e) {
  return new Promise((r) => {
    const o = new FormData();
    (o.append("items[0][id]", String(t)),
      o.append("items[0][quantity]", String(e)),
      o.append("items[0][properties][_type]", "engraving-fee"));
    const a = (i) => {
      const { requestState: n } = i.detail ?? {};
      n?.requestType === "add" &&
        (document.removeEventListener("liquid-ajax-cart:request-end", a), r());
    };
    (document.addEventListener("liquid-ajax-cart:request-end", a), window.liquidAjaxCart.add(o));
  });
}
function I() {
  document.querySelector("[data-engraving-fee-variant-id]") &&
    document.addEventListener("liquid-ajax-cart:request-end", (t) => {
      const { requestState: e } = t.detail ?? {};
      e?.responseData?.ok && (q || T());
    });
}
function V() {
  function t() {
    const e = C(),
      r = window.liquidAjaxCart?.cart;
    if (!r) return;
    let o = 0;
    e &&
      r.items &&
      (o = r.items.filter((i) => i.variant_id === e).reduce((i, n) => i + n.quantity, 0));
    const a = Math.max(0, r.item_count - o);
    document.querySelectorAll("[data-cart-visible-count]").forEach((i) => {
      i.textContent = a;
    });
  }
  document.addEventListener("liquid-ajax-cart:request-end", t);
}
document.querySelector("[data-dialog], [data-modal]") &&
  m(
    () => import("./dialog-BaBkMkeu.js").then((t) => t.d),
    __vite__mapDeps([0, 1, 2, 3, 4]),
    import.meta.url
  );
document.querySelector("a[data-policy-modal]") &&
  m(() => import("./policy-modal-D91e2YU7.js"), [], import.meta.url);
document.readyState === "complete" ? g() : window.addEventListener("load", g);
function g() {
  document.querySelector("carousel-embla") &&
    m(() => import("./carousel-embla-g3Tm5yad.js"), __vite__mapDeps([5, 1, 2, 6]), import.meta.url);
}
document.querySelector("[data-predictive-search], predictive-search-component") &&
  m(
    () => import("./predictive-search-Cg925ss_.js").then((t) => t.p),
    __vite__mapDeps([7, 1, 2, 8, 3]),
    import.meta.url
  );
document.querySelector(".kaching-bundles-deal-block-settings") &&
  m(() => import("./kaching-bundle-price-Z--iVqaA.js"), [], import.meta.url);
function _() {
  return window.liquidAjaxCart && typeof window.liquidAjaxCart.conf == "function"
    ? (window.liquidAjaxCart.conf("binderFormatters", { money: (t) => S(parseFloat(t)) }),
      window.liquidAjaxCart.conf("updateOnWindowFocus", !1),
      !0)
    : !1;
}
_() ||
  document.addEventListener("liquid-ajax-cart:init", () => {
    _();
  });
b();
I();
V();
(function () {
  const e = new Set();
  let r,
    o = null;
  document.addEventListener("mouseover", (a) => {
    const i = a.target.closest("a[href]");
    if (i === o || (clearTimeout(r), (o = i), !i)) return;
    const n = i.href;
    !n ||
      !n.startsWith(location.origin) ||
      e.has(n) ||
      (r = setTimeout(() => {
        const c = document.createElement("link");
        ((c.rel = "prefetch"), (c.href = n), document.head.appendChild(c), e.add(n));
      }, 200));
  });
})();
